export * from './file.component';
